<template>
  <v-autocomplete
    v-model="valores"
    :items="itens"
    clearable
    :label="`${isAT ? 'Atividades' : 'Tarefas'}`"
    item-text="nome"
    item-value="tarefaId"
    multiple
    :return-object="true"
    v-on:change="$emit('onChange', valores)"
    :disabled="!filter.solucao.municipioSolucaoId"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="valores.length > 0 ? 'indigo darken-4' : ''">{{
          iconMultiple
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ valores.length - maxDisplay }}
        {{ isAT ? "atividades" : "tarefas" }})</span
      >
    </template>
    <template slot="no-data">
      Nenhuma {{ isAT ? "Atividades" : "Tarefas" }} retornada
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppCityTaskCombobox",
  props: ["filter", "itens"],
  data() {
    return {
      maxDisplay: 2,
      valores: [],
    };
  },
  watch: {
    filter: {
      handler() {
        this.valores = [];
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["user", "isAT"]),
    likesAll() {
      return this.valores.length === this.itens.length;
    },
    likesSome() {
      return this.valores.length > 0 && !this.itens;
    },
    iconMultiple() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.valores = [];
          this.$emit("onChange", this.valores);
        } else {
          this.valores = this.itens.slice();
          this.$emit("onChange", this.valores);
        }
      });
    },
  },
};
</script>
